import { render, staticRenderFns } from "./StatsKpiTab.vue?vue&type=template&id=8ccd8a88&"
import script from "./StatsKpiTab.vue?vue&type=script&lang=js&"
export * from "./StatsKpiTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiTab.vue?vue&type=style&index=0&id=8ccd8a88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports